(() => {
  const chat = document.querySelector('shopify-chat[data-cotigo-chat-cart]');
  if (!chat) return;
  const root = document.documentElement;
  const compact = matchMedia('(max-width:749px)');
  let activeBar;
  let frame;
  let previewHeight = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = undefined; sync(); });
  };
  const sizeObserver = new ResizeObserver(schedule);
  const barObserver = new MutationObserver(schedule);
  const bindBars = () => {
    document.querySelectorAll('.sticky-add-to-cart__bar').forEach(bar => {
      if (bar.dataset.chatCartBound) return;
      bar.dataset.chatCartBound = 'true';
      sizeObserver.observe(bar);
      barObserver.observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
    });
    document.querySelectorAll('sticky-add-to-cart').forEach(host => {
      barObserver.observe(host, { attributes: true, attributeFilter: ['data-variant-available'] });
    });
    schedule();
  };
  const sync = () => {
    const ready = chat.matches(':defined');
    activeBar = [...document.querySelectorAll('.sticky-add-to-cart__bar[data-stuck="true"]')].find(bar => bar.closest('sticky-add-to-cart')?.dataset.variantAvailable === 'true');
    const active = ready && Boolean(activeBar);
    root.toggleAttribute('data-cotigo-chat-ready', ready);
    root.toggleAttribute('data-cotigo-sticky-chat', active);
    root.toggleAttribute('data-cotigo-chat-open', chat.hasAttribute('open'));
    const viewport = window.visualViewport;
    const keyboard = viewport ? Math.max(0, innerHeight - viewport.height - viewport.offsetTop) : 0;
    previewHeight = parseFloat(getComputedStyle(chat).getPropertyValue('--private-preview-bar-offset')) || 0;
    const barHeight = activeBar?.getBoundingClientRect().height || 0;
    const baseBottom = compact.matches ? 0 : 20;
    root.style.setProperty('--cotigo-chat-viewport', (viewport?.height || innerHeight) + 'px');
    root.style.setProperty('--cotigo-keyboard-offset', keyboard + 'px');
    root.style.setProperty('--cotigo-preview-offset', previewHeight + 'px');
    root.style.setProperty('--cotigo-chat-bottom', (keyboard + previewHeight + baseBottom + (active ? barHeight + 12 : 20)) + 'px');
    root.style.setProperty('--cotigo-chat-room', Math.max(100, (viewport?.height || innerHeight) - previewHeight - baseBottom - (active ? barHeight + 12 : 20) - 16) + 'px');
    document.querySelectorAll('.sticky-add-to-cart__bar').forEach(bar => {
      const hidden = bar.dataset.stuck !== 'true' || bar.closest('sticky-add-to-cart')?.dataset.variantAvailable !== 'true';
      bar.inert = hidden;
      bar.setAttribute('aria-hidden', String(hidden));
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && chat.hasAttribute('open')) chat.close();
  });
  new MutationObserver(schedule).observe(chat, { attributes: true, attributeFilter: ['open'] });
  new MutationObserver(() => {
    if ((parseFloat(getComputedStyle(chat).getPropertyValue('--private-preview-bar-offset')) || 0) !== previewHeight) schedule();
  }).observe(root, { attributes: true, attributeFilter: ['style'] });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  compact.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', bindBars);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  customElements.whenDefined('shopify-chat').then(schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindBars, { once: true });
  else bindBars();
})();
